<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>买家保证金</span>
      </div>
      <div>
        <el-alert :title="'为了保证拍卖正常进行，请您缴纳买家保证金（'+money+'元）'" type="success" :closable="false">
        </el-alert>
        <div class="dep-container">
          <div class="price-main">
            <div class="">我的保证金</div>
            <div class="price">￥{{credit}}</div>
          </div>
          <el-button @click="handleDep" type="primary" plain>{{text}}</el-button>
          <el-button plain @click="refundDeposit">申请退还</el-button>
        </div>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false" title="提示" @close="clearOrderQueryInterval" :visible.sync="showDialog">
      <div class="qrcode clearfix">
        <div class="qrcode-img"><img :src="QRImages" alt=""></div>
        <div class="">
          <p>使用微信扫描上方二维码即可完成支付。 订单已生成，如果未完成支付，请刷新页面重试</p>
          <el-button type="primary" plain @click="payOrderQuery">支付成功</el-button>
          <el-popover placement="top-start" title="出错了？" width="200" trigger="click" content="没有看到二维码？请刷新页面试试">
            <el-button slot="reference">遇到问题</el-button>
          </el-popover>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" scoped>
.dep-container {
  padding: 30px 20px;
}
.price-main {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  .price {
    color: #de3f34;
    font-weight: 700;
    font-size: 38px;
    font-family: Tahoma;
    line-height: 58px;
  }
}
.qrcode {
  .qrcode-img {
    width: 120px;
    height: 120px;
    float: left;
    background: #333;
    margin-right: 20px;
    & ~ div {
      vertical-align: middle;
    }
  }
}
</style>
<script>
import {
  Customer
} from "../../model/customer.js";
let customer = new Customer();
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'deposit',
  data() {
    return {
      payType: 'NATIVE',
      type: 1,//支付类型 0:客户保证金 1:艺术家保证金 2:秒杀或者商城 3：订单
      showDialog: false,
      callId: '',
      return_url: this.$route.query.return_url,
      money: 0,//用户需要缴纳的保证金
      vip: 0,
      credit: 0,
      isclick: '',
      QRImages: '',
      timer: 0,
      COUNT: 0,
      MAXCOUNT: 6
    }
  },
  components: {

  },
  computed: {
    text() {
      let _this = this;
      if (parseFloat(_this.credit) >= parseFloat(_this.money)) {
        return '已缴纳'
      } else if (_this.vip) {
        return '无需缴纳'
      } else {
        return '立即缴纳'
      }
    }
  },
  methods: {
    handleDep() {
      let _this = this;
      usercenter.createNativePayOrder({
        Type: 0,
        CustomerId: _this.user ? _this.user.id : ''
      }).then((res) => {
        _this.QRImages = res.QRUrl;
        _this.showDialog = true;
        _this.orderId = res.OrderId;
        this.timer && clearInterval(this.timer);
        this.payOrderQuery()
        this.timer = setInterval(() => {
          _this.COUNT++;
          _this.intervalOrderQuery()
        }, 10000);
      }, () => {
      })
    },
    getCustomerCredit() {
      let _this = this;
      customer.customerCredit({
        union_id: _this.user ? _this.user.union_id : ''
      }).then((res) => {
        _this.money = parseFloat(res.EarnestMoney || 100);
        _this.vip = res.IsCustomerVIP;
        _this.vip = res.IsCustomerVIP;
        _this.credit = res.CustomerCredit;
        _this.isclick = false;
        if (parseFloat(_this.credit) >= parseFloat(_this.money)) {
          _this.isclick = true;
        } else if (_this.vip) {
          _this.isclick = true;
        }
      })
    },
    payOrderQuery() {
      let _this = this;
      usercenter.payOrderQuery({
        OrderId: _this.orderId,
        PayType: _this.payType
      }).then(() => {
        this.$message({
          message: '订单支付成功',
          type: 'success'
        });
        _this.clearOrderQueryInterval();
        setTimeout(() => {
          location.reload();
        }, 2000);
      }, () => {
        console.log('正在支付中，请稍候')
      })
    },
    intervalOrderQuery() {
      if (this.COUNT >= this.MAXCOUNT) {
        this.$message({
          message: '支付失败，请重试',
          type: 'error'
        });
        this.clearOrderQueryInterval();
      } else {
        this.payOrderQuery();
      }
    },
    clearOrderQueryInterval() {
      this.showDialog = false;
      clearInterval(this.timer)
    },
    refundDeposit() {
      let _this = this;
      _this.$confirm('申请退款后您将不能出价', '重要提示', {
        confirmButtonText: '确认申请',
        cancelButtonText: '点错了',
        type: 'warning'
      }).then(() => {
        usercenter.refundDeposit({
          CustomerId: _this.user ? _this.user.id : "",
          ArtistId: '',
          OrderType: 3
        }).then(function () {
          _this.$message({
            message: '保证金退款申请成功，系统正在处理中，请留意',
            type: 'success'
          });
        })
      }).catch(() => { });
    },
  },
  created() {
    this.getCustomerCredit()
  },
  destroyed() {
    this.clearOrderQueryInterval()
  }
}
</script>